import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    Box,
    Icon,
} from '@chakra-ui/react';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';

const ToolResultModal = ({ isOpen, onClose, isSuccess, message }) => {

    const parseErrorMessageObject = (msg) => {
        if (typeof msg !== 'string') return { error: 'Unknown error' };

        try {
            const match = msg.match(/{.*}/);
            if (match) {
                const fixed = match[0]
                    .replace(/'/g, '"') // convert single to double quotes
                    .replace(/"(\w+)":/g, '"$1":') // ensure property keys are properly quoted
                    .replace(/\\"/g, '"');

                const parsed = JSON.parse(fixed);
                return parsed;
            }
        } catch (e) {
            return { response: msg }; // fallback
        }

        return { response: msg };
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius="16px" maxW="420px">
                <ModalHeader color={isSuccess ? 'green.500' : 'red.500'}>
                    {isSuccess ? 'Tool Testing Successful' : 'Tool Testing Failed'}
                </ModalHeader>
                <ModalCloseButton style={{ color: !isSuccess ? "#E53E3E" : "#A0AEC0" }} />

                <ModalBody>
                    <Box display="flex" alignItems="center" gap={3} mb={2}>
                        {/* <Icon
                            as={isSuccess ? CheckCircleIcon : WarningIcon}
                            color={isSuccess ? 'green.400' : 'red.400'}
                            boxSize={6}
                        /> */}
                        <Box
                            width="100%"
                            as="pre"
                            fontSize="sm"
                            color={isSuccess ? 'green.600' : 'red.600'}
                            backgroundColor={isSuccess ? 'green.50' : 'red.50'}
                            p={3}
                            borderRadius="md"
                            whiteSpace="pre-wrap"
                            overflowX="auto"
                        >
                            {JSON.stringify(parseErrorMessageObject(message), null, 2)}
                        </Box>


                    </Box>
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme={isSuccess ? 'green' : 'red'} onClick={onClose}
                        w="100%"
                    >
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ToolResultModal;
